/* Rquiere de mixin.js */

var jumpseller = {
	data () {
		return {
			listJumpsellerOrders: [],
			listJumpsellerProducts: [],
            listJumpsellerOrderStatus: [
                { status: 'Abandoned', spanish:'Abandonado', class: 'jump-bg-abandoned'},
                { status: 'Canceled', spanish:'Cancelado', class: 'jump-bg-canceled'},
                { status: 'PendingPayment', spanish:'Pendiente de Pago', class: 'jump-bg-pending-payment'},
                { status: 'Paid', spanish:'Pagado', class: 'jump-bg-paid'},
            ],
			methods: {
				jumpsellerOrderGet: 'jumpseller/orders',
				jumpsellerProductGet: 'jumpseller/products',
				jumpsellerLinkClientGet: 'jumpseller/link/client/',
				jumpsellerLinkOrderGet: 'jumpseller/link/order/'
			},
			paginationJumpsellerOrders: [],
			qRowsJumpsellerOrder: 20,
			pageCurrent: 1,
			searchJumpsellerOrders: '',
			searchingJumpsellerOrders: false,
			searchingJumpsellerLinkClient: false,
			searchingJumpsellerLinkOrder: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		classJumpsellerOrderStatus(status) {
			let class_ = ''
			let index = this.listJumpsellerOrderStatus.map(el => (el.status)).indexOf(status)
			if(index > -1) {
				class_ = this.listJumpsellerOrderStatus[index].class
			}
			return class_
		},
		getAllJumpsellerOrders(page = 1) {
			let parameters = '?page=' + page + '&limit=' + this.qRowsJumpsellerOrder
			let url = this.getApiBackend + this.methods.jumpsellerOrderGet + parameters
			this.searchingJumpsellerOrders = true
			this.axiosActionIS(url, 'GET', 'getAllJumpsellerOrdersResult')
        },
		getAllJumpsellerOrdersResult(response) {
			this.searchingJumpsellerOrders = false
            if(response.data.success){
                this.listJumpsellerOrders = response.data.data;
            }
		},
		getAllJumpsellerOrdersStatus(page = 1, status) {
			let parameters = '?page=' + page + '&limit=' + this.qRowsJumpsellerOrder
			let url = this.getApiBackend + this.methods.jumpsellerOrderGet + parameters
			this.searchingJumpsellerOrders = true
			this.axiosActionIS(this.getApiBackend + this.methods.jumpsellerOrderGet+ '/' + status + parameters, 'GET', 'getAllJumpsellerOrdersResult')
		},
		getAllJumpsellerProducts(page = 1) {
			let url = this.getApiBackend + this.methods.jumpsellerProductGet
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getAllJumpsellerProductsResult')
		},
		getAllJumpsellerProductsResult(response) {
			if(response.data.success == true) {
				this.listJumpsellerProducts = response.data.data
			}
			this.getAllJumpsellerProductsResultLocal(response)
		},
		getAllJumpsellerProductsResultLocal(response) {
			console.log('getAllJumpsellerProductsResultLocal no desarrollado', response)
		},
		showLinkJumpsellerClient(jumpsellerClientId) {
			this.searchingJumpsellerLinkClient = true
			let url = this.getApiBackend + this.methods.jumpsellerLinkClientGet + jumpsellerClientId
			this.axiosActionIS(url, 'GET', 'showLinkJumpsellerClientResult', null)
		},
		showLinkJumpsellerClientResult(response) {
			this.searchingJumpsellerLinkClient = false
			this.showLinkJumpsellerClientResultLocal(response)
		},
		showLinkJumpsellerClientResultLocal(response) {
			console.log('showLinkJumpsellerClientResultLocal no desarrollado', response)
		},
		showLinkJumpsellerOrder(jumpsellerOrderId) {
			this.searchingJumpsellerLinkOrder = true
			let url = this.getApiBackend + this.methods.jumpsellerLinkOrderGet + jumpsellerOrderId
			this.axiosActionIS(url, 'GET', 'showLinkJumpsellerOrderResult', null)
		},
		showLinkJumpsellerOrderResult(response) {
			this.searchingJumpsellerLinkOrder = false
			this.showLinkJumpsellerOrderResultLocal(response)
		},
		showLinkJumpsellerOrderResultLocal(response) {
			console.log('showLinkJumpsellerOrderResultLocal no desarrollado', response)
		},
		spanishJumpsellerOrderStatus(status) {
			let spanish = ''
			let index = this.listJumpsellerOrderStatus.map(el => (el.status)).indexOf(status)
			if(index > -1) {
				spanish = this.listJumpsellerOrderStatus[index].spanish
			}
			return spanish
		},
	},
};

export default jumpseller;